(function () {
  "use strict";

  function initQuiz(mount) {

    var SECTION = mount.getAttribute("data-section-id") || "0";
    var root = mount.querySelector(".rq-root");
    if (!root) return;

    function readJSON(sel, fallback) {
      var el = mount.querySelector(sel);
      if (!el) return fallback;
      try { return JSON.parse(el.textContent); } catch (e) { return fallback; }
    }

    var SETTINGS = readJSON("[data-rq-settings]", {});
    var RAW = readJSON("[data-rq-products]", {});

    function money(cents) {
      if (cents === null || cents === undefined) return "";
      return "$" + (cents / 100).toFixed(2);
    }

    // Turn a Shopify product object into what the quiz needs.
    function shape(raw, role, blurb) {
      if (!raw || !raw.id) return null;
      var variants = (raw.variants || []).filter(function (v) { return v.available !== false; });
      if (!variants.length) variants = raw.variants || [];
      if (!variants.length) return null;
      return {
        id: raw.id,
        name: raw.title,
        role: role,
        url: "/products/" + raw.handle,
        image: raw.image || raw.featured_image || null,
        blurb: blurb,
        variants: variants.map(function (v) {
          return { id: v.id, title: v.title, price: v.price, available: v.available !== false };
        }),
        selected: 0
      };
    }

    // Copy is deliberately drawn from the wording already published on each
    // product page, so nothing new is being claimed here.
    var P = {
      sleep:      shape(RAW.sleep, "Evening capsule", "Two capsules before bed. Supports a calm, natural bedtime routine and helps manage restlessness and disturbed nights."),
      stress:     shape(RAW.stress, "Daily capsule", "For the stretch where everything is on at once. Supports your natural stress response and helps restore calm."),
      focus:      shape(RAW.focus, "Morning capsule", "Taken in the morning, before the day starts making decisions for you. Supports mental clarity and concentration."),
      magnesium:  shape(RAW.magnesium, "Evening capsule", "The quiet foundation under everything else. Supports refreshing, restful sleep and muscle relaxation."),
      hydrate:    shape(RAW.hydrate, "Daily electrolyte", "One sachet through your first litre. Replenishes lost electrolytes and supports fluid balance and normal muscle function."),
      creatine_w: shape(RAW.creatine_w, "Daily powder", "Five grams a day, any time you like. Supports strength, lean muscle tone and recovery, and it is one of the most researched sports supplements in the world."),
      creatine_m: shape(RAW.creatine_m, "Daily powder", "Five grams a day, any time you like. Supports strength, power and training performance, and aids muscle recovery between sessions."),
      glutamine:  shape(RAW.glutamine, "Daily powder", "An unflavoured scoop that disappears into water. Supports gut health, immune defence and cellular repair.")
    };

    var TRIALS = {
      sleep: shape(RAW.trial_sleep, "7 night trial", ""),
      stress: shape(RAW.trial_stress, "7 day trial", ""),
      focus: shape(RAW.trial_focus, "7 day trial", ""),
      magnesium: shape(RAW.trial_magnesium, "7 night trial", "")
    };

    // A bundle is only ever offered when it contains exactly what we already
    // recommended, and the saving shown is calculated from live prices.
    var BUNDLES = [
      { key: "bundle_sleep", set: ["sleep", "magnesium"],
        body: "Magnesium Glycinate and Sleep, the two evening formulas we just recommended, in one order." },
      { key: "bundle_calm", set: ["stress", "sleep"],
        body: "Stress through the day and Sleep at night, the pair we just recommended, in one order." },
      { key: "bundle_focus", set: ["focus", "magnesium"],
        body: "Focus in the morning and Magnesium in the evening, the pair we just recommended, in one order." },
      { key: "bundle_performance", set: ["creatine_w", "glutamine"],
        body: "Creatine for Women 300g and L-Glutamine, the training duo we just recommended, in one order." }
    ];

    var RITUALS = {
      sleep:      { name: "The Wind Down" },
      stress:     { name: "The Steady" },
      focus:      { name: "The Clear Head" },
      creatine:   { name: "The Strong Build" },
      hydrate:    { name: "The Long Day" },
      magnesium:  { name: "The Deep Reset" },
      glutamine:  { name: "The Rebuild" }
    };

    var QUESTIONS = [
      { id: "goal", eyebrow: "The starting point",
        q: "What would you most like to change right now?",
        helper: "Pick the one that has been on your mind the longest.",
        opts: [
          { label: "Getting to sleep, and staying there", sub: "Nights that do not land", goal: "sleep", s: { sleep: 4, magnesium: 2 }, because: "sleep is the thing you would fix first" },
          { label: "Feeling calmer and less stretched", sub: "Running at full noise", goal: "stress", s: { stress: 4, magnesium: 1 }, because: "you are feeling stretched thin" },
          { label: "Clearer thinking and less fog", sub: "Concentration and mental clarity", goal: "focus", s: { focus: 4 }, because: "you want a clearer head" },
          { label: "Strength, tone and training results", sub: "Getting more from the work", goal: "creatine", s: { creatine: 4, glutamine: 1 }, because: "you want more back from your training" },
          { label: "Steady energy through the day", sub: "Hydration and the afternoon slump", goal: "hydrate", s: { hydrate: 4, magnesium: 1 }, because: "your energy runs out before the day does" },
          { label: "Recovery and gut comfort", sub: "Sore, slow, or run down", goal: "glutamine", s: { glutamine: 4, magnesium: 1 }, because: "recovery is what you are chasing" }
        ] },
      { id: "nights", eyebrow: "Your nights",
        q: "How do your nights usually go?",
        helper: "Think about a normal week, not your best one.",
        opts: [
          { label: "I lie there with my mind ticking over", sub: "Hard to switch off", s: { sleep: 3, stress: 1 }, because: "your mind ticks over at night" },
          { label: "I fall asleep fine but wake through the night", sub: "Broken sleep", s: { sleep: 2, magnesium: 2 }, because: "your sleep breaks up through the night" },
          { label: "Restless legs, cramping or muscle tension", sub: "The body will not settle", s: { magnesium: 3, sleep: 1 }, because: "your body struggles to settle at night" },
          { label: "I sleep well, no complaints", sub: "Nights are sorted", s: {}, because: null }
        ] },
      { id: "stress", eyebrow: "Your load",
        q: "And the stress load lately?",
        helper: "Work, family, business, all of it.",
        opts: [
          { label: "Full noise, most days", sub: "Not much let up", s: { stress: 3, sleep: 1, magnesium: 1 }, because: "most days are running at full noise" },
          { label: "Busy, but I am on top of it", sub: "Manageable", s: { stress: 2 }, because: "your weeks are busy but manageable" },
          { label: "It comes in waves around deadlines", sub: "Peaks and troughs", s: { stress: 1, focus: 1 }, because: "the pressure comes in waves" },
          { label: "Pretty settled at the moment", sub: "Nothing unusual", s: {}, because: null }
        ] },
      { id: "head", eyebrow: "Your head",
        q: "Where does your head sit during the day?",
        helper: "Between the first coffee and the last email.",
        opts: [
          { label: "Foggy, and slow to get going", sub: "Mornings are a fight", s: { focus: 3 }, because: "mornings start in a fog" },
          { label: "Sharp early, gone by mid afternoon", sub: "The 3pm drop", s: { focus: 2, hydrate: 1 }, because: "you lose the thread by mid afternoon" },
          { label: "Scattered, hard to stay on one thing", sub: "Too many tabs open", s: { focus: 2, stress: 1 }, because: "focus is scattered across too many things" },
          { label: "Clear and switched on", sub: "No issues", s: {}, because: null }
        ] },
      { id: "training", eyebrow: "Your training",
        q: "How are you training at the moment?",
        helper: "Whatever movement actually happens in a normal week.",
        opts: [
          { label: "Strength or weights, three or more times a week", sub: "Lifting consistently", s: { creatine: 3, glutamine: 1 }, because: "you are lifting consistently" },
          { label: "Mixed, walking, pilates, reformer or yoga", sub: "Regular but lower intensity", s: { creatine: 1, magnesium: 1 }, because: "you move regularly at a lower intensity" },
          { label: "High sweat, running, HIIT or hot classes", sub: "You finish sessions drenched", s: { hydrate: 3, creatine: 1, glutamine: 1 }, because: "you finish sessions drenched" },
          { label: "Not training right now", sub: "Life is full enough", s: {}, because: null }
        ] },
      { id: "creatine_pick", eyebrow: "One detail",
        q: "If creatine makes the list, which one should we show you?",
        helper: "Same micronised creatine monohydrate in both, different serve size and tub.",
        showIf: function (a) { return a.goal === 3 || a.training === 0 || a.training === 2; },
        opts: [
          { label: "Creatine for Women", sub: "", s: { creatine_pref: "w" }, because: null },
          { label: "Creatine for Men", sub: "", s: { creatine_pref: "m" }, because: null }
        ] },
      { id: "hydration", eyebrow: "Your days",
        q: "How is your hydration through the day?",
        helper: "Be honest, we have all had the coffee only morning.",
        opts: [
          { label: "I run on coffee and forget the water", sub: "Water is an afterthought", s: { hydrate: 3 }, because: "water tends to be an afterthought" },
          { label: "I drink plenty but still feel flat", sub: "Fluids in, energy out", s: { hydrate: 2, magnesium: 1 }, because: "you drink plenty and still feel flat" },
          { label: "I sweat a lot, climate or training", sub: "Losing more than most", s: { hydrate: 3 }, because: "you lose a lot through sweat" },
          { label: "All good on that front", sub: "Well hydrated", s: {}, because: null }
        ] },
      { id: "approach", eyebrow: "Last one",
        q: "Where are you up to with supplements?",
        helper: "This decides whether we start you small or set up the full routine.",
        opts: [
          { label: "New to this, I would rather try before I commit", sub: "Start me on a trial pack", s: {}, mode: "trial", because: null },
          { label: "I know what I want, send the full size", sub: "Straight to the real thing", s: {}, mode: "full", because: null },
          { label: "I want a proper routine, morning and night", sub: "Build me the full ritual", s: {}, mode: "ritual", because: null },
          { label: "I take a few things already, just filling gaps", sub: "One addition, not an overhaul", s: {}, mode: "gap", because: null }
        ] }
    ];

    var state = { view: "intro", step: 0, answers: {}, result: null };

    function visibleQuestions() {
      return QUESTIONS.filter(function (q) { return !q.showIf || q.showIf(state.answers); });
    }

    function creatineProduct(pref) {
      var wanted = pref === "m" ? P.creatine_m : P.creatine_w;
      return wanted || P.creatine_w || P.creatine_m;
    }

    function resolve(key, res) {
      if (key === "creatine") return creatineProduct(res.pref);
      return P[key];
    }

    function score() {
      var totals = { sleep: 0, stress: 0, focus: 0, creatine: 0, hydrate: 0, magnesium: 0, glutamine: 0 };
      var reasons = [], pref = "w", mode = "full", goalKey = null;

      visibleQuestions().forEach(function (q) {
        var i = state.answers[q.id];
        if (i === undefined) return;
        var opt = q.opts[i];
        if (!opt) return;
        if (opt.mode) mode = opt.mode;
        if (opt.goal) goalKey = opt.goal;
        Object.keys(opt.s || {}).forEach(function (k) {
          if (k === "creatine_pref") { pref = opt.s[k]; return; }
          totals[k] = (totals[k] || 0) + opt.s[k];
        });
        if (opt.because) reasons.push(opt.because);
      });

      // Never recommend something the store cannot currently sell.
      var ranked = Object.keys(totals)
        .filter(function (k) { return !!resolve(k, { pref: pref }); })
        .map(function (k) { return { key: k, score: totals[k] }; })
        .sort(function (a, b) { return b.score - a.score; });

      var top = ranked.filter(function (r) { return r.score > 0; });
      var primaryKey, supportKeys;

      if (!top.length) {
        primaryKey = ranked.length ? ranked[0].key : "hydrate";
        supportKeys = [];
      } else {
        var leader = top[0];
        var goalScore = goalKey ? (totals[goalKey] || 0) : 0;
        var goalAvailable = goalKey && resolve(goalKey, { pref: pref });
        primaryKey = (goalAvailable && (leader.score - goalScore) < 3) ? goalKey : leader.key;

        supportKeys = top
          .filter(function (r) { return r.key !== primaryKey && r.score >= 3; })
          .slice(0, 2).map(function (r) { return r.key; });

        if (goalAvailable && primaryKey !== goalKey && supportKeys.indexOf(goalKey) === -1) {
          supportKeys.unshift(goalKey);
          supportKeys = supportKeys.slice(0, 2);
        }
      }

      return {
        totals: totals, primaryKey: primaryKey, supportKeys: supportKeys,
        reasons: reasons, mode: mode, pref: pref,
        ritual: RITUALS[primaryKey] || { name: "The Foundation" }
      };
    }

    // Only offer a bundle whose contents exactly match what we recommended.
    function findBundle(res) {
      var chosen = [res.primaryKey].concat(res.supportKeys).map(function (k) {
        if (k !== "creatine") return k;
        return res.pref === "m" ? "creatine_m" : "creatine_w";
      });
      if (chosen.length < 2) return null;

      for (var i = 0; i < BUNDLES.length; i++) {
        var b = BUNDLES[i];
        var raw = RAW[b.key];
        if (!raw || !raw.id) continue;
        var matches = b.set.every(function (k) { return chosen.indexOf(k) !== -1; });
        if (!matches) continue;

        var bundleVariant = (raw.variants || []).filter(function (v) { return v.available !== false; })[0];
        if (!bundleVariant) continue;

        var separate = 0, ok = true;
        b.set.forEach(function (k) {
          var prod = P[k] || (k === "creatine_w" ? P.creatine_w : k === "creatine_m" ? P.creatine_m : null);
          if (!prod) { ok = false; return; }
          separate += prod.variants[0].price;
        });
        if (!ok) continue;

        return {
          name: raw.title, url: "/products/" + raw.handle,
          variantId: bundleVariant.id, price: bundleVariant.price,
          saving: separate - bundleVariant.price, body: b.body
        };
      }
      return null;
    }

    function esc(s) {
      return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
        return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
      });
    }

    function sentence(list) {
      if (!list.length) return "";
      if (list.length === 1) return list[0];
      return list.slice(0, -1).join(", ") + " and " + list[list.length - 1];
    }

    // ---------- views ----------
    function render() {
      if (state.view === "intro") return renderIntro();
      if (state.view === "quiz") return renderQuestion();
      if (state.view === "calc") return renderCalc();
      if (state.view === "results") return renderResults();
    }

    function renderIntro() {
      root.innerHTML =
        '<div class="rq-stage"><div class="rq-shell rq-intro rq-panel">' +
          '<p class="rq-eyebrow">Find your ritual</p>' +
          '<h2>' + esc(SETTINGS.heading) + '</h2>' +
          '<p>' + esc(SETTINGS.intro) + '</p>' +
          '<div class="rq-meta rq-eyebrow"><span>About 60 seconds</span><span>No email needed to see your result</span></div>' +
          '<button class="rq-btn rq-btn-gold" type="button" data-action="start">Start the quiz</button>' +
        '</div></div>';
    }

    function renderQuestion() {
      var qs = visibleQuestions();
      var q = qs[state.step];
      var ticks = "";
      for (var i = 0; i < qs.length; i++) {
        ticks += '<div class="rq-tick" data-filled="' + (i < state.step ? "true" : "false") + '"></div>';
      }
      var opts = q.opts.map(function (o, i) {
        return '<button class="rq-option" type="button" data-pick="' + i + '" aria-pressed="' +
          (state.answers[q.id] === i ? "true" : "false") + '">' +
          '<span class="rq-key" aria-hidden="true">' + String.fromCharCode(65 + i) + '</span>' +
          '<span class="rq-opt-label">' + esc(o.label) +
          (o.sub ? '<span class="rq-opt-sub">' + esc(o.sub) + '</span>' : "") +
          '</span></button>';
      }).join("");

      root.innerHTML =
        '<div class="rq-stage"><div class="rq-shell">' +
          '<div class="rq-progress" role="progressbar" aria-valuemin="1" aria-valuemax="' + qs.length + '" aria-valuenow="' + (state.step + 1) + '">' + ticks + '</div>' +
          '<div class="rq-panel">' +
            '<p class="rq-eyebrow rq-step-count">Question ' + (state.step + 1) + ' of ' + qs.length + ' &nbsp;/&nbsp; ' + esc(q.eyebrow) + '</p>' +
            '<h2 class="rq-question">' + esc(q.q) + '</h2>' +
            '<p class="rq-helper">' + esc(q.helper) + '</p>' +
            '<div class="rq-options">' + opts + '</div>' +
            '<div class="rq-nav"><button class="rq-back" type="button" data-action="back"' + (state.step === 0 ? " hidden" : "") + '>Back</button></div>' +
          '</div>' +
        '</div></div>';
    }

    function renderCalc() {
      root.innerHTML =
        '<div class="rq-stage"><div class="rq-shell rq-calc rq-panel">' +
          '<p>Building your ritual</p><span class="rq-dots" aria-hidden="true"><i></i><i></i><i></i></span>' +
        '</div></div>';
      setTimeout(function () {
        state.result = score();
        state.result.bundle = findBundle(state.result);
        state.view = "results";
        render();
        pushEvent();
        if (mount.scrollIntoView) mount.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 1000);
    }

    function variantPicker(prod, slot) {
      if (!prod.variants || prod.variants.length < 2) return "";
      return '<div class="rq-variants" role="group" aria-label="Choose an option">' +
        prod.variants.map(function (v, i) {
          return '<button class="rq-variant" type="button" data-variant="' + i + '" data-slot="' + slot + '" aria-pressed="' +
            (prod.selected === i ? "true" : "false") + '">' + esc(v.title) + ' ' + money(v.price) + '</button>';
        }).join("") + '</div>';
    }

    function productCard(prod, slot, opts) {
      opts = opts || {};
      var v = prod.variants[prod.selected] || prod.variants[0];
      var img = prod.image
        ? '<img class="rq-thumb" src="' + esc(prod.image) + '" alt="" loading="lazy" width="108" height="108">'
        : "";
      var actions = opts.hero
        ? '<div class="rq-card-actions">' +
            '<button class="rq-btn rq-btn-forest" type="button" data-add="' + slot + '">Add to cart ' + money(v.price) + '</button>' +
            '<a class="rq-btn rq-btn-ghost" href="' + prod.url + '">View product</a>' +
          '</div>'
        : '<div class="rq-card-actions">' +
            '<button class="rq-btn rq-btn-ghost" type="button" data-add="' + slot + '">Add ' + money(v.price) + '</button>' +
          '</div>';

      return '<div class="rq-card' + (opts.hero ? " rq-card-hero" : "") + '" data-card="' + slot + '">' +
        '<div class="rq-card-body">' + img + '<div class="rq-card-main">' +
          '<p class="rq-eyebrow rq-role">' + (opts.hero ? "Start here &nbsp;/&nbsp; " : "") + esc(prod.role) + '</p>' +
          '<div class="rq-card-top"><h3>' + esc(prod.name) + '</h3><span class="rq-price">' + money(v.price) + '</span></div>' +
          (prod.blurb ? '<p class="rq-blurb">' + esc(prod.blurb) + '</p>' : "") +
          variantPicker(prod, slot) +
          actions +
        '</div></div></div>';
    }

    function renderResults() {
      var res = state.result;
      var hero = resolve(res.primaryKey, res);
      var useTrial = res.mode === "trial" && TRIALS[res.primaryKey];
      var heroProd = useTrial ? TRIALS[res.primaryKey] : hero;
      heroProd.blurb = heroProd.blurb || hero.blurb;

      // Someone who asked to try before committing gets trial sizes the whole
      // way down, not a $14.95 hero next to two full size tubs.
      state.slots = { hero: heroProd };
      res.supportKeys.forEach(function (k, i) {
        var full = resolve(k, res);
        var prod = (res.mode === "trial" && TRIALS[k]) ? TRIALS[k] : full;
        prod.blurb = prod.blurb || full.blurb;
        state.slots["s" + i] = prod;
      });

      var because = res.reasons.length
        ? 'You told us <b>' + esc(sentence(res.reasons.slice(0, 3))) + '</b>. That is why we have started you here.'
        : 'Here is where we would start you.';

      var supports = "";
      if (res.supportKeys.length) {
        supports = '<div class="rq-divider"><span class="rq-eyebrow">Worth adding</span></div><div class="rq-support">' +
          res.supportKeys.map(function (k, i) { return productCard(state.slots["s" + i], "s" + i, {}); }).join("") +
          '</div>';
      } else {
        supports = '<div class="rq-divider"><span class="rq-eyebrow">And that is it</span></div>' +
          '<p class="rq-because">Nothing else in your answers needed attention, so we have left it at one. ' +
          'Come back when something changes.</p>';
      }

      var bundle = "";
      if (res.bundle && !useTrial) {
        bundle = '<div class="rq-bundle"><div>' +
          '<p class="rq-eyebrow">Both of these come as a stack</p>' +
          '<h3>' + esc(res.bundle.name) + ' ' + money(res.bundle.price) + '</h3>' +
          '<p>' + esc(res.bundle.body) + '</p>' +
          (res.bundle.saving > 0 ? '<span class="rq-save">Saves ' + money(res.bundle.saving) + '</span>' : "") +
          '</div><button class="rq-btn rq-btn-gold" type="button" data-add-bundle="1">Add the stack</button></div>';
      }

      var capture = "";
      if (SETTINGS.showCapture) {
        capture = '<div class="rq-capture" id="rq-capture-' + SECTION + '">' +
          '<h3>' + esc(SETTINGS.captureHeading) + '</h3>' +
          '<p>' + esc(SETTINGS.captureBody) + '</p>' +
          '<form class="rq-form" novalidate>' +
            '<label class="rq-sr" for="rq-name-' + SECTION + '">First name</label>' +
            '<input id="rq-name-' + SECTION + '" type="text" placeholder="First name" autocomplete="given-name">' +
            '<label class="rq-sr" for="rq-email-' + SECTION + '">Email</label>' +
            '<input id="rq-email-' + SECTION + '" type="email" placeholder="Email address" autocomplete="email" required>' +
            '<button class="rq-btn rq-btn-forest" type="submit">Send it</button>' +
          '</form>' +
          '<p class="rq-error" hidden></p>' +
          '<p class="rq-consent">By sending this you agree to receive marketing emails from Ritua. Unsubscribe any time.</p>' +
        '</div>';
      }

      root.innerHTML =
        '<div class="rq-results"><div class="rq-shell rq-panel">' +
          '<div class="rq-result-head">' +
            '<p class="rq-eyebrow">Your ritual</p>' +
            '<h2 class="rq-ritual-name">' + esc(res.ritual.name) + '</h2>' +
            '<p class="rq-because">' + because + '</p>' +
          '</div>' +
          productCard(heroProd, "hero", { hero: true }) +
          supports + bundle +
          checkoutBar() +
          capture +
          '<p class="rq-footnote">This quiz is a product guide, not health advice. Always read the label and follow the directions for use. ' +
          'If you are pregnant, breastfeeding, taking medication or managing a health condition, speak with your doctor or pharmacist before starting any supplement.</p>' +
          '<button class="rq-restart" type="button" data-action="restart">Retake the quiz</button>' +
        '</div></div>';
    }

    function allSlots() {
      return Object.keys(state.slots || {});
    }

    function ritualTotal() {
      return allSlots().reduce(function (sum, slot) {
        var p = state.slots[slot];
        var v = p.variants[p.selected] || p.variants[0];
        return sum + v.price;
      }, 0);
    }

    function checkoutBar() {
      var n = allSlots().length;
      if (n < 2) return "";
      return '<div class="rq-checkout"><div>' +
        '<div class="rq-checkout-total" data-total>' + money(ritualTotal()) + '</div>' +
        '<p class="rq-checkout-sub">' + n + ' products, your full ritual</p>' +
        '</div><button class="rq-btn rq-btn-forest" type="button" data-add-all="1">Add the whole ritual to cart</button></div>';
    }

    function refreshTotal() {
      var el = root.querySelector("[data-total]");
      if (el) el.textContent = money(ritualTotal());
    }

    function goToCart(pairs) {
      window.location.href = "/cart/" + pairs.join(",");
    }

    // ---------- Klaviyo ----------
    function answerProperties() {
      var res = state.result || {};
      var props = {
        quiz_ritual: res.ritual ? res.ritual.name : "",
        quiz_primary_product: res.primaryKey ? (resolve(res.primaryKey, res) || {}).name : "",
        quiz_supporting_products: (res.supportKeys || []).map(function (k) { return (resolve(k, res) || {}).name; }).join(", "),
        quiz_mode: res.mode || "",
        quiz_bundle: res.bundle ? res.bundle.name : "None"
      };
      visibleQuestions().forEach(function (q) {
        var i = state.answers[q.id];
        if (i !== undefined && q.opts[i]) props["quiz_" + q.id] = q.opts[i].label;
      });
      Object.keys(res.totals || {}).forEach(function (k) { props["quiz_score_" + k] = res.totals[k]; });
      return props;
    }

    function pushEvent() {
      try {
        window._learnq = window._learnq || [];
        window._learnq.push(["track", "Completed Product Quiz", answerProperties()]);
      } catch (e) {}
    }

    function subscribe(name, email, done) {
      var props = answerProperties();
      try {
        window._learnq = window._learnq || [];
        var id = { $email: email };
        if (name) id.$first_name = name;
        Object.keys(props).forEach(function (k) { id[k] = props[k]; });
        window._learnq.push(["identify", id]);
      } catch (e) {}

      if (!SETTINGS.klaviyoKey || !SETTINGS.klaviyoList) { done(true); return; }

      fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + encodeURIComponent(SETTINGS.klaviyoKey), {
        method: "POST",
        headers: { "Content-Type": "application/json", "revision": "2024-10-15" },
        body: JSON.stringify({
          data: { type: "subscription", attributes: {
            profile: { data: { type: "profile", attributes: {
              email: email, first_name: name || undefined, properties: props
            } } }
          }, relationships: { list: { data: { type: "list", id: SETTINGS.klaviyoList } } } }
        })
      }).then(function (r) { done(r.ok); }).catch(function () { done(false); });
    }

    // ---------- events ----------
    root.addEventListener("click", function (e) {
      var action = e.target.closest("[data-action]");
      if (action) {
        var a = action.getAttribute("data-action");
        if (a === "start") { state.view = "quiz"; state.step = 0; render(); return; }
        if (a === "back") { state.step = Math.max(0, state.step - 1); render(); return; }
        if (a === "restart") {
          state = { view: "intro", step: 0, answers: {}, result: null };
          render();
          if (mount.scrollIntoView) mount.scrollIntoView({ behavior: "smooth", block: "start" });
          return;
        }
      }

      var variant = e.target.closest("[data-variant]");
      if (variant) {
        var slot = variant.getAttribute("data-slot");
        var prod = state.slots[slot];
        prod.selected = parseInt(variant.getAttribute("data-variant"), 10);
        var card = root.querySelector('[data-card="' + slot + '"]');
        card.querySelectorAll("[data-variant]").forEach(function (b) {
          b.setAttribute("aria-pressed", b === variant ? "true" : "false");
        });
        var v = prod.variants[prod.selected];
        card.querySelector(".rq-price").textContent = money(v.price);
        var addBtn = card.querySelector("[data-add]");
        if (addBtn) addBtn.textContent = (slot === "hero" ? "Add to cart " : "Add ") + money(v.price);
        refreshTotal();
        return;
      }

      var add = e.target.closest("[data-add]");
      if (add) {
        var s = add.getAttribute("data-add");
        var p = state.slots[s];
        var vv = p.variants[p.selected] || p.variants[0];
        goToCart([vv.id + ":1"]);
        return;
      }

      if (e.target.closest("[data-add-all]")) {
        goToCart(allSlots().map(function (slot) {
          var pr = state.slots[slot];
          return (pr.variants[pr.selected] || pr.variants[0]).id + ":1";
        }));
        return;
      }

      if (e.target.closest("[data-add-bundle]")) {
        goToCart([state.result.bundle.variantId + ":1"]);
        return;
      }

      var pick = e.target.closest("[data-pick]");
      if (pick) {
        var qs = visibleQuestions();
        var q = qs[state.step];
        state.answers[q.id] = parseInt(pick.getAttribute("data-pick"), 10);
        pick.setAttribute("aria-pressed", "true");
        setTimeout(function () {
          var updated = visibleQuestions();
          var idx = updated.indexOf(q);
          var next = (idx === -1 ? state.step : idx) + 1;
          if (next >= updated.length) { state.view = "calc"; render(); }
          else { state.step = next; render(); }
        }, 200);
      }
    });

    root.addEventListener("submit", function (e) {
      if (!e.target.classList.contains("rq-form")) return;
      e.preventDefault();
      var form = e.target;
      var name = form.querySelector('input[type="text"]').value.trim();
      var email = form.querySelector('input[type="email"]').value.trim();
      var err = form.parentNode.querySelector(".rq-error");
      var btn = form.querySelector("button");

      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        err.textContent = "That email does not look right. Check it and try again.";
        err.hidden = false;
        return;
      }
      err.hidden = true;
      btn.disabled = true;
      btn.textContent = "Sending";

      subscribe(name, email, function (ok) {
        if (!ok) {
          btn.disabled = false;
          btn.textContent = "Send it";
          err.textContent = "That did not send. Try again in a moment, or add your ritual to cart above.";
          err.hidden = false;
          return;
        }
        var box = document.getElementById("rq-capture-" + SECTION);
        box.innerHTML = '<h3>' + (name ? "Sent, " + esc(name) + "." : "Sent.") + '</h3>' +
          '<p class="rq-consent">Your ritual is on its way to ' + esc(email) + '.</p>';
      });
    });

    if (window.__RQ_TEST) {
      window.__RQ_API = { QUESTIONS: QUESTIONS, state: state, score: score, findBundle: findBundle,
        resolve: resolve, visibleQuestions: visibleQuestions, P: P, TRIALS: TRIALS };
    }

    render();
  }

  function boot() {
    var mounts = document.querySelectorAll("[data-ritua-quiz]");
    for (var i = 0; i < mounts.length; i++) {
      if (mounts[i].getAttribute("data-rq-ready")) continue;
      mounts[i].setAttribute("data-rq-ready", "1");
      initQuiz(mounts[i]);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else { boot(); }

  // Shopify theme editor re-renders sections without a page reload.
  document.addEventListener("shopify:section:load", boot);
})();
